import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense } from 'react'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { runsTableColumns } from './runsTableColumns'

export function DatabricksRunsSection() {
  return (
    // <SectionContainer title="Runs">
    <QueryErrorBoundary errorMessage="Failed to load runs">
      <Suspense fallback={<LoadingComponent text="Loading runs" />}>
        <DatabricksRunsSectionContent />
      </Suspense>
    </QueryErrorBoundary>
    // {/* </SectionContainer> */}
  )
}

function DatabricksRunsSectionContent() {
  const { getDatabricksApiListJobRuns } = useRestClient()
  const currentWorkspace = useCurrentWorkspace()
  const { workspaceId } = currentWorkspace
  const { data: workspaceRuns } = getDatabricksApiListJobRuns.useSuspenseQuery({ path: { workspaceId } })

  return <DataTable title="Runs" columns={runsTableColumns} data={workspaceRuns} />
}
